import React from 'react';

import Filters from '../filters';
import { useTasks } from '../context/tasks_context';

import type { ReactNode } from 'react';
import type { Props as FiltersProps } from '../filters';

export type TasksFiltersProps = Omit<FiltersProps, 'children' | 'oneLine' | 'onChange' | 'onChangePending'> & {
  children?: ReactNode;
  oneLine?: boolean;
};

export function TasksFilters({ children, features: _features, userId: _userId, ...rest }: TasksFiltersProps) {
  const { features, forUser, setFilters, setLoading } = useTasks();

  return (
    <Filters
      {...rest}
      features={features}
      userId={forUser.id}
      onChange={setFilters}
      onChangePending={() => setLoading(true)}
    >
      {children}
    </Filters>
  );
}
